<script setup>
/* eslint-disable */
import Header from '@/components/Common/header.vue';
import MobileMenu from '@/components/Common/mobileMenu.vue';
import Footer from "@/components/Common/Footer.vue";
import MyBetsSlips from "./Bets/MyBetsSlips.vue";
import MyEditBetsSlips from '@/views/Bets/MyEditBetsSlips.vue';
import HorseRacingFrame from '@/components/horse_racing/HorseRacingFrame.vue';
import { useInitializeStore } from '@/stores/initialize';
import { EditBetSlip } from '@/stores/edit_betslip';
import { onMounted } from 'vue';
import { useHorseRacingStore } from '@/stores/horse_racing';

const initializeStore = useInitializeStore();
const editBetslipStore = EditBetSlip();
const horseRacingStore = useHorseRacingStore();

onMounted(() => {
	// Reset any previous errors when mounting
	horseRacingStore.error = null;
});

</script>

<template>
	<div class="main_div horse-racing-page">
		<Header></Header>

		<!-- fixed mobile bottom menu-->
		<div class="fixed-btm-main">
			<div class="container-full fix-padding">
				<MobileMenu></MobileMenu>
			</div>
		</div>

		<div class="horse-racing-main">
			<div class="container-full">
				<div class="horse-racing-content">
					<HorseRacingFrame :mobile="false" :auto-load="true"></HorseRacingFrame>
				</div>
			</div>
		</div>

		<!-- footer start -->
		<MyEditBetsSlips v-if="initializeStore.isSportsbookEnabled && editBetslipStore.edit_mode_enabled" />
		<MyBetsSlips v-if="initializeStore.isSportsbookEnabled && !editBetslipStore.edit_mode_enabled"/>
		<Footer></Footer>
	</div>
</template>

<style scoped>
.horse-racing-page {
	min-height: 100vh;
	background: #1a1d24;
}

.horse-racing-main {
	padding: 1.5rem 0;
}

.horse-racing-content {
	background: #1a1d24;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
	.horse-racing-main {
		padding: 0;
		min-height: auto;
	}
	
	.horse-racing-content {
		border-radius: 0;
		min-height: auto;
	}
}
</style>
